import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";
import { SurveyEvent } from "../../app/models/survey";
import { RootStoreContext } from "../../app/stores/rootStore";
import InfoMessage from "../common/InfoMessage";
import AddSurvey from "./AddSurvey";
import SurveyActionModal from "./SurveyActionModal";
import SurveyContainerVoteResults from "./SurveyContainerVoteResults";
import SurveyList from "./SurveyList";

const SurveyContainer: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { theme, selectedLanguageId } = rootStore.commonStore;
  const {
    loadSurveys,
    view,
    surveyId,
    isSmallModalOpen,
    setIsSmallModalOpen,
    actionName,
    deleteSurvey,
    clearAnswers,
    EventSurvey,
    resetSurveySignalRParameters,
    computedSurveyMeetingId,
    computedSurveyNodeId
  } = rootStore.surveyStore;
  const [t] = useTranslation(["surveys"], translationHookOptions);


  useEffect(() => {
    return () => {
      resetSurveySignalRParameters()
    }
  }, [resetSurveySignalRParameters])

  if (!computedSurveyMeetingId)
    return (
      <InfoMessage
        icon="fa fa-exclamation-circle fa-3x"
        color={theme!.infoMessageColor}
        message={t("survey_list_zero")}
      />
    );

  return (
    <>
      {view === "list" ? (
        <SurveyList meetingId={computedSurveyMeetingId} nodeId={computedSurveyNodeId}></SurveyList>
      ) : null}
      {view === "addEdit" ? (
        <AddSurvey
          meetingId={computedSurveyMeetingId}
          nodeId={computedSurveyNodeId}
          surveyId={surveyId > 0 ? surveyId : null}
        ></AddSurvey>
      ) : null}
      {view === "result" || view === "vote" ? (
        <SurveyContainerVoteResults
          meetingId={computedSurveyMeetingId}
          surveyId={surveyId}
        ></SurveyContainerVoteResults>
      ) : null}
      {isSmallModalOpen && (
        <SurveyActionModal
          meetingId={computedSurveyMeetingId}
          surveyId={surveyId}
          isOpen={isSmallModalOpen}
          actionName={actionName}
          toggle={() => setIsSmallModalOpen(!isSmallModalOpen)}
          onSubmit={() => {
            let surveyevent = new SurveyEvent();
            if (actionName === "Delete") {
              deleteSurvey(surveyId)
                .then(() => {
                  loadSurveys(computedSurveyMeetingId, selectedLanguageId).then().catch();
                })
                .catch();
            }
            if (actionName === "Open") {
              surveyevent.event = "Open";
              surveyevent.meetingId = computedSurveyMeetingId;
              EventSurvey(surveyId, surveyevent)
                .then(() => {
                  loadSurveys(computedSurveyMeetingId, selectedLanguageId).then().catch();
                })
                .catch();
            }
            if (actionName === "Close") {
              surveyevent.event = "Close";
              surveyevent.meetingId = computedSurveyMeetingId;
              EventSurvey(surveyId, surveyevent)
                .then(() => {
                  loadSurveys(computedSurveyMeetingId, selectedLanguageId).then().catch();
                })
                .catch();
            }
            if (actionName === "Archivie") {
              surveyevent.event = "Archivie";
              surveyevent.meetingId = computedSurveyMeetingId;
              EventSurvey(surveyId, surveyevent)
                .then(() => {
                  loadSurveys(computedSurveyMeetingId, selectedLanguageId).then().catch();
                })
                .catch();
            }
            if (actionName === "Clear") {
              clearAnswers(surveyId)
                .then(() => {
                  loadSurveys(computedSurveyMeetingId, selectedLanguageId).then().catch();
                })
                .catch();
            }
          }}
        ></SurveyActionModal>
      )}
    </>
  );
};

export default observer(SurveyContainer);
